<template>
  <div>
    <el-row class="systemFont1" style="margin-top: 20px;margin-bottom: 20px;">
      <el-col :span="18" :offset="3">
        <!-- 上课日期时间 -->
        <el-col :span="8"
          >{{ $t("p0416.dateTime") }}：{{
            createTimeFormat(detailList)
          }}</el-col
        >
        <!-- 课程编号 -->
        <el-col :span="6"
          >{{ $t("p0416.courseNumber") }}：{{
            detailList.courseNumberView
          }}</el-col
        >
        <!-- 课程名称 -->
        <el-col :span="8"
          >{{ $t("p0416.courseName") }}：{{ detailList.courseName }}</el-col
        >
      </el-col>
      <!-- 导出 -->
      <el-col :span="2">
        <el-button
          type="exportInfo"
          @click="exportCommissionExcel"
          style="margin-top:-5px"
          >{{ $t("p0416.export") }}</el-button
        >
      </el-col>
    </el-row>
    <el-table
      :data="userList"
      tooltip-effect="dark"
      style="margin:auto"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        align="center"
        min-width="30"
      ></el-table-column>
      <!-- 介绍人 -->
      <el-table-column
        prop="introduceName"
        :label="$t('p0416.introducer')"
        align="center"
        min-width="80"
      ></el-table-column>
      <!-- 手机号 -->
      <el-table-column
        prop="phoneNo"
        :label="$t('p0416.phone')"
        align="center"
        min-width="95"
      ></el-table-column>
      <!-- 关联公司 -->
      <el-table-column
        prop="company"
        :label="$t('p0416.company')"
        align="left"
        min-width="140"
      ></el-table-column>
      <!-- 优惠码 -->
      <el-table-column
        prop="couponCode"
        :label="$t('p0416.couponCode')"
        align="center"
        min-width="65"
      ></el-table-column>
      <!-- 介绍人数 -->
      <el-table-column
        prop="introduceNum"
        :label="$t('p0416.introduceNum')"
        align="center"
        min-width="65"
      ></el-table-column>
      <!-- 单人佣金 -->
      <el-table-column
        prop="singleCommission"
        :label="$t('p0416.singleCommission')"
        align="center"
        min-width="65"
      ></el-table-column>
      <!-- 佣金总额 -->
      <el-table-column
        prop="totalCommission"
        :label="$t('p0416.totalCommission')"
        align="center"
        min-width="65"
      >
      </el-table-column>
      <!-- 货币 -->
      <el-table-column
        prop="currencyView"
        :label="$t('p0416.currency')"
        align="center"
        min-width="40"
      >
      </el-table-column>
      <!-- 操作 -->
      <el-table-column
        :label="$t('common.operation')"
        align="center"
        min-width="40"
      >
        <template slot-scope="scope">
          <el-button size="text" @click="pay(scope.row)">{{
            $t("p0416.pay")
          }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row class="foot-container" style="margin-bottom: 50px;">
      <el-col :span="12">
        <!--批量支付  -->
        <el-button
          type="p0332Button"
          @click="bulkPay"
          :disabled="payToSomeFlag"
          >{{ $t("p0416.bulkPayments") }}</el-button
        >
      </el-col>
      <el-col :span="12">
        <!-- 返回 -->
        <el-button type="return" @click="returnBack(1)">{{
          $t("common.back")
        }}</el-button>
      </el-col>
    </el-row>

    <!-- 支付框 -->
    <el-dialog
      :title="$t('p0416.pay')"
      :visible.sync="payDialogVisible"
      width="35%"
      :close-on-click-modal="false"
      center
      class="dialog"
      @close="cancel(0)"
    >
      <el-form
        ref="payForm"
        :rules="rules"
        :model="payForm"
        label-width="120px"
        hide-required-asterisk
      >
        <el-form-item :label="$t('p0416.selectPaymentTime')" prop="paymentTime">
          <el-date-picker
            type="datetime"
            :placeholder="$t('p0416.pleaseSelectDateTime')"
            v-model="payForm.paymentTime"
            style="width: 100%;"
          ></el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('p0416.uploadPayProof')" prop="locationCode">
          <uploadFile
            ref="uploadCardFile_1"
            :uploadButtonStyle="uploadButtonStyle"
            :uploadFile="{
              locationCode: locationCode,
              uploadBtnDisplayFlag: uploadBtnDisplayFlag
            }"
            :uploadDisable="saveFlag"
          >
          </uploadFile>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="p0332Button" @click="payToOne()">{{
          $t("common.submit")
        }}</el-button>
        <el-button type="return" @click="cancel(0)">{{
          $t("common.back")
        }}</el-button>
      </span>
    </el-dialog>

    <!-- 批量支付框 -->
    <el-dialog
      :title="$t('p0416.bulkPayments')"
      :visible.sync="payDialogVisible1"
      width="35%"
      :close-on-click-modal="false"
      center
      class="dialog"
      @close="cancel(1)"
    >
      <el-form
        ref="payFormSome"
        :rules="rules"
        :model="payFormSome"
        label-width="120px"
        hide-required-asterisk
      >
        <el-form-item :label="$t('p0416.selectPaymentTime')" prop="paymentTime">
          <el-date-picker
            type="datetime"
            :placeholder="$t('p0416.pleaseSelectDateTime')"
            v-model="payFormSome.paymentTime"
            style="width: 100%;"
          ></el-date-picker>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="p0332Button" @click="payToSome()">{{
          $t("common.submit")
        }}</el-button>
        <el-button type="return" @click="cancel(1)">{{
          $t("common.back")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import qs from "qs";
import moment from "moment";
import uploadFile from "../../../components/Common/UploadAttachment.vue";
import { build20Id } from "../../../utils/buildId.js";
export default {
  components: {
    uploadFile
  },
  props: {
    detailList: Object
  },
  data() {
    return {
      // 上传文件列表
      uploadFileList: [],
      uploadButtonStyle: 2,
      // 位置关联Code
      locationCode: build20Id(),
      // 上传按钮控件是否显示按钮（重新加载用）
      uploadFileReloadFlag: true,
      saveFlag: false,
      // 上传按钮显示标志
      uploadBtnDisplayFlag: true,
      // 支付form
      payForm: {
        paymentTime: ""
      },
      // 批量支付form
      payFormSome: {
        paymentTime: ""
      },
      // 选择的用户
      multipleSelection: [],
      // 支付弹框
      payDialogVisible: false,
      // 批量支付弹框
      payDialogVisible1: false,
      // 批量支付/单个支付标识
      // paymentFlag: true,
      // 批量支付禁用标识
      payToSomeFlag: true,
      // 查询参数
      params: {},
      userList: [],
      rules: {
        paymentTime: [
          {
            type: "date",
            required: true,
            message: this.$t("p0416.pleaseSelectDateTime"),
            trigger: ["blur", "change"]
          }
        ]
      }
    };
  },
  watch: {
    "multipleSelection.length": function(val) {
      if (val === 0) {
        this.payToSomeFlag = true;
      } else {
        this.payToSomeFlag = false;
      }
    }
  },
  methods: {
    cancel(flag) {
      console.log("🚀 ~ file: P0419.vue:282 ~ cancel ~ flag:", flag);
      if (flag === 1) {
        // 关闭弹框
        this.payDialogVisible1 = false;
        // 清空校验+数据
        this.$refs.payFormSome.resetFields();
      } else {
        // 关闭弹框
        this.payDialogVisible = false;
        // 清空上传文件列表
        this.$refs.uploadCardFile_1.uploadFileList = [];
        // 清空校验+数据
        this.$refs.payForm.resetFields();
      }
    },
    // 待结算明细导出
    exportCommissionExcel() {
      console.log(this.params);
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      let url = "/api/greenJacketOrder/exportCommissionExcel";
      this.$http
        .get(url, { params: this.params, responseType: "blob" })
        .then(response => {
          console.log("文件下载成功", response.data);
          const blob = new Blob([response.data]);
          console.log("blob", blob);
          if (blob.size == 0) {
            this.$message({
              message: this.$t("p0416.noFindCommissionInfo"),
              type: "warning"
            });
            loading.close();
          } else {
            const fileName =
              this.params.courseNumberView +
              moment(this.params.dateAndTime).format("YYYYMMDDHHmm") +
              this.$t("p0352.exportFileFormat");
            //对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
            //IE10以上支持blob，但是依然不支持download
            if ("download" in document.createElement("a")) {
              console.log("download1");
              //支持a标签download的浏览器
              const link = document.createElement("a"); //创建a标签
              link.download = fileName; //a标签添加属性
              link.style.display = "none";
              link.href = URL.createObjectURL(blob);
              document.body.appendChild(link);
              link.click(); //执行下载
              URL.revokeObjectURL(link.href); //释放url
              document.body.removeChild(link); //释放标签
            } else {
              // console.log("download2");
              navigator.msSaveBlob(blob, fileName);
            }
            loading.close();
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error(this.$t("p0416.ExportFail"));
          loading.close();
        });
    },
    // 附件提交
    async upload() {
      // 风险分析1
      await this.$refs.uploadCardFile_1.submitUploadFile();
    },
    // 初始化数据
    getPayCommissionList() {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        spinner: "el-icon-loading",
        background: "hsla(0, 0%, 100%, 0.9)",
        target: document.querySelector("#main-container")
      });
      let url = "/api/greenJacketOrder/searchCommissionDetail";
      this.$http
        .post(url, qs.stringify(this.params))
        .then(response => {
          loading.close();
          if (response.data.code === 200) {
            // 获取待结算佣金列表
            this.userList = response.data.data;
            console.log(
              "🚀 ~ file: P0414.vue:141 ~ getPayCommissionList ~ response.data.data",
              response.data.data
            );
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          loading.close();
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 改变上传文件的状态
    changeUploadFileStatus() {
      // console.log(this.uploadFile.uploadBtnDisplayFlag) //= !this.uploadFile.uploadBtnDisplayFlag;
      this.uploadBtnDisplayFlag = !this.uploadBtnDisplayFlag;
      this.reloadUploadFile();
    },
    // 单个支付
    payToOne() {
      this.$refs.payForm.validate(valid => {
        if (valid) {
          // console.log("params", this.params);
          // console.log("pay", this.payForm);
          // console.log("location", this.locationCode);
          this.upload();
          if (this.$refs.uploadCardFile_1.uploadFileList.length == 0) {
            this.locationCode = null;
          }
          console.log(this.$refs.uploadCardFile_1.uploadFileList);
          let url = "/api/greenJacketOrder/payToOne";
          let payParams = {
            commissionPayTime: moment(this.payForm.paymentTime).format(
              "YYYY-MM-DD HH:mm:ss"
            ),
            field: this.params.field,
            category: this.params.category,
            courseNumber: this.params.courseNumber,
            dateAndTime: this.params.dateAndTime,
            couponCode: this.payForm.couponCode,
            singleCommission: this.payForm.singleCommission,
            totalCommission: this.payForm.totalCommission,
            locationCode: this.locationCode,
            userId: localStorage.getItem("userId")
          };
          console.log(payParams);
          this.$http
            .post(url, payParams)
            .then(response => {
              // loading.close();
              if (response.data.code === 200) {
                this.$message.success(response.data.message);
                // 重新加载数据
                this.getPayCommissionList();
                // 重新获取localtionCode
                this.locationCode = build20Id();
                // 关闭弹框
                this.payDialogVisible = false;
                // 清空校验+数据
                this.$refs.payForm.resetFields();
                // 清空上传文件列表
                this.$refs.uploadCardFile_1.uploadFileList = [];
              } else {
                // loading.close();
                this.$message.error(this.$t("p0416.optionFaild"));
              }
            })
            .catch(err => {
              console.log(err);
              // loading.close();
              this.$message.error(this.$t("common.anErrorOccurred"));
            });
        }
      });
    },
    // 批量支付
    payToSome() {
      this.$refs.payFormSome.validate(valid => {
        if (valid) {
          // console.log(this.multipleSelection);
          let url = "/api/greenJacketOrder/payToSome";
          // let payToSome = []
          let payParams = {
            commissionPayTime: moment(this.payFormSome.paymentTime).format(
              "YYYY-MM-DD HH:mm:ss"
            ),
            field: this.params.field,
            category: this.params.category,
            courseNumber: this.params.courseNumber,
            dateAndTime: this.params.dateAndTime,
            payToSome: this.multipleSelection,
            userId: localStorage.getItem("userId")
          };
          console.log(payParams);
          this.$http
            .post(url, payParams)
            .then(response => {
              // loading.close();
              if (response.data.code === 200) {
                this.$message.success(response.data.message);
                // 重新加载数据
                this.getPayCommissionList();
                // 关闭弹框
                this.payDialogVisible1 = false;
                // 清空校验+数据
                this.$refs.payFormSome.resetFields();
              } else {
                // loading.close();
                this.$message.error(this.$t("p0416.optionFaild"));
              }
            })
            .catch(err => {
              console.log(err);
              // loading.close();
              this.$message.error(this.$t("common.anErrorOccurred"));
            });
        }
      });
    },
    // 重新加载上传附件控件
    async reloadUploadFile() {
      this.uploadFileReloadFlag = false;
      await this.$nextTick();
      this.uploadFileReloadFlag = true;
    },
    //选择的用户
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    bulkPay() {
      if (this.multipleSelection.length > 0) {
        // 打开弹框
        this.payDialogVisible1 = true;
      } else {
        this.$message.error(this.$t("p0416.pleaseSelectUser"));
      }
    },
    // 查询明细
    pay(row) {
      // 打开支付弹框
      this.payDialogVisible = true;
      //
      this.payForm = { ...row };
    },
    // 返回上一页
    returnBack() {
      // 调用自定义事件，传入参数
      this.$emit("getViewFlag", true);
    },
    //创建日期格式化时间
    createTimeFormat(row) {
      if (row.dateAndTime != null && row.dateAndTime != "") {
        return moment(row.dateAndTime).format("YYYY-MM-DD HH:mm");
      }
    }
  },
  mounted() {
    // console.log(this.detailList);
    this.params = {
      field: this.detailList.courseNumberView.substring(0, 2),
      category: this.detailList.courseNumberView.substring(2, 4),
      courseNumber: this.detailList.courseNumberView.substring(4, 6),
      courseNumberView: this.detailList.courseNumberView,
      dateAndTime: this.detailList.dateAndTime
    };
    this.getPayCommissionList();
  }
};
</script>

<style lang="scss" scoped>
.main {
  width: 90%;
  margin: 0 auto;
  padding-top: 17px;
  display: flex;
}
.foot-container {
  margin-top: 5%;
  margin-left: 40%;
  width: 20%;
  text-align: center;
}
>>> .el-table__row {
  height: 42px;
}
>>> .el-table thead {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  color: #333333;
  font-size: 16px;
}
>>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  line-height: 18px;
  border-bottom: 0.5px solid rgb(170, 170, 170);
}
>>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background: none;
}
>>> .el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170);
}
//弹出框屏幕居中
>>> .el-dialog {
  left: 50%;
  top: 40%;
  transform: translate(-50%, -50%);
  margin: 0px !important;
  // height: 50vh;
  // overflow: auto;
}
//弹出框内容居中
>>> .el-dialog .el-dialog__body {
  display: flex;
  justify-content: center;
  align-items: center;
}
/* 导出发票信息 */
.el-button--exportInfo {
  background-color: #00b0f0;
  border-color: rgb(0, 176, 240);
  width: 80px;
  height: 30px;
  white-space: pre-wrap;
  padding: 0;
  font-family: "微软雅黑";
  font-weight: 400;
  font-style: normal;
  color: #ffffff;
  font-size: 13px;
  line-height: 18px;
}
</style>



// WEBPACK FOOTER //
// src/views/Marketing/CouponCode/P0419.vue